import { render } from "./aboutMy.vue?vue&type=template&id=278d2d91&scoped=true&ts=true"
import script from "./aboutMy.vue?vue&type=script&lang=ts"
export * from "./aboutMy.vue?vue&type=script&lang=ts"

import "./aboutMy.vue?vue&type=style&index=0&id=278d2d91&scoped=true&lang=less"
import "./aboutMy.vue?vue&type=style&index=1&id=278d2d91&lang=css"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278d2d91"]])

export default __exports__